import Button from 'Components/Button';
import ModalComponent from 'Components/Modal';
import { useState } from 'react';
import CreditoService from 'Services/Http/Credito.service';
import PropTypes from 'prop-types';

const ButtonDelete = (props) => {
  const { id, refresh } = props;
  const [stateModal, setStateModal] = useState(false);
  const [messageModal, setMessageModal] = useState('');

  const deleteButton = () => {
    setStateModal(true);
    setMessageModal('Desea eliminar la solicitud');
  };
  const changeState = (state) => {
    setStateModal(state);
  };
  const actionOK = async (data, loaderState, close) => {
    loaderState(true);
    try {
      await CreditoService.cierreSolicitudProspecto(id, data);
      loaderState(false);
      refresh();
      close();
    } catch (e) {
      console.log(e);
      close();
      loaderState(false);
    }
  };
  return (
    <>
      <ModalComponent
        show={stateModal}
        changeState={changeState}
        typeModal="cerrarSolicitud"
        title={messageModal}
        stateModal={'success'}
        actionOK={actionOK}
      />
      <Button color={'error'} iconprefix={['fa', 'trash']} onClick={() => deleteButton(id)} />
    </>
  );
};

ButtonDelete.propTypes = {
  /**
   * Button label
   */
  id: PropTypes.number,
  refresh: PropTypes.func
};

export default ButtonDelete;
